import Battery, {Answer} from "../../Battery/Battery";
import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import NumericScaleItem from "../../shared/components/NumericScaleItem/NumericScaleItem";
import h from "../../../ui/design";

export default class BatteryNumericScale extends Battery {

    private readonly numericScales: NumericScaleItem[] = [];
    private readonly dontKnows: (Answer|null)[] = [];

    constructor(setting: ICustomFormSettings) {
        super(setting);

        for (const card of this.questionCards) {
            let dkAnswer = null;
            const radios = [];
            for (const answer of card.answers) {
                if (answer.radio.getValue() === '99') {
                    dkAnswer = answer;
                } else {
                    radios.push(answer.radio);
                }
            }

            this.dontKnows.push(dkAnswer);
            const numericScaleItem = new NumericScaleItem(radios);
            numericScaleItem.afterPickValue = () => this.onAnswerSelect();
            this.numericScales.push( numericScaleItem );

        }
    }

    viewOptions(): Vnode|null {
        if (this.currentOptionsIndex === null) {
            return null;
        }

        return m('.',  {}, [
            m(this.numericScales[this.currentOptionsIndex]),
            this.viewDK(),
        ]);
    }

    private viewDK(): Vnode|null {
        if (this.currentOptionsIndex === null || !this.dontKnows[this.currentOptionsIndex]) {
            return null;
        }
        const answer = this.dontKnows[this.currentOptionsIndex]!;
        const radio = answer.radio;

        return m(".radioCell",  {}, [
            m("label", {}, [
                m("input", {
                    type: "radio",
                    value: '99',
                    tabindex: 1,
                    onclick: () => this.onAnswerSelect(answer),
                    checked: radio.isChecked(),
                }),
                m("span"+(radio.isChecked() ? h.backgroundSecondary : ''), {},
                    m('.option-label', {}, m.trust(this.settings.form.questionary.renderText(answer.label)) )
                )
            ])
        ]);


    }

}
